import {Drawer} from 'presentation/components/Drawer';
import {Filter} from 'presentation/components/Filter';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {Stack} from '@mui/material';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {ExamResultsTaggingEnum} from 'main/analytics/gaTagsEnum';

import {FilterDrawerProps} from './types';
import {useFilterHeader} from 'presentation/modules/examResults/hooks/useFilterHeader';

const {filterAuthorizations} = translations['pt-br'].commons;

export const FilterDrawer = ({isWaitingResult}: FilterDrawerProps) => {
	const {isMobile} = useMediaQueries();
	const {
		openDrawerState,
		handleOpenDrawer,
		handleCloseDrawer,
		listFilters,
		handleApplyFilter,
		handleClearFilter,
		IS_ALL,
	} = useFilterHeader();

	return (
		<Fragment>
			<Filter.Button
				onClick={handleOpenDrawer}
				count={IS_ALL ? 0 : 1}
				data-tag-id={
					isWaitingResult
						? ExamResultsTaggingEnum.CLICK_FILTRAR_AGUARDANDO_LIBERACAO
						: ExamResultsTaggingEnum.CLICK_FILTRAR_LIBERADOS
				}
			/>
			<Drawer.Root
				open={openDrawerState}
				onOpen={handleOpenDrawer}
				width="420px"
				onClose={handleCloseDrawer}
				sx={{zIndex: 9000}}>
				<Drawer.Header
					title={filterAuthorizations}
					onClose={handleCloseDrawer}
					closeBtnDataTagId={
						isWaitingResult
							? ExamResultsTaggingEnum.CLICK_FECHAR_FILTRO_RESULTADO_DE_EXAMES_AGUARDANDO_LIBERACAO
							: ExamResultsTaggingEnum.CLICK_FECHAR_FILTRO_RESULTADO_DE_EXAMES_LIBERADOS
					}
				/>

				<Stack mb={1.5} mt={isMobile ? 0 : 1} flex={1}>
					<Drawer.ContentListByCategory categoryList={listFilters} />
				</Stack>

				<Drawer.Footer
					firstButtonOnClick={handleClearFilter}
					firstButtonDataTagId={
						isWaitingResult
							? ExamResultsTaggingEnum.CLICK_LIMPAR_FILTRO_RESULTADO_DE_EXAMES_AGUARDANDO_LIBERACAO
							: ExamResultsTaggingEnum.CLICK_LIMPAR_FILTRO_RESULTADO_DE_EXAMES_LIBERADOS
					}
					secondButtonOnClick={handleApplyFilter}
					secondButtonDataTagId={
						isWaitingResult
							? ExamResultsTaggingEnum.CLICK_APLICAR_FILTRO_TIPO_EXAMES_AGUARDANDO_LIBERACAO
							: ExamResultsTaggingEnum.CLICK_APLICAR_FILTRO_TIPO_EXAMES_LIBERADOS
					}
				/>
			</Drawer.Root>
		</Fragment>
	);
};
